import { AuditLogDiff } from "@common/types/auditLog";

export function getDiffEntry(
    diffs: AuditLogDiff[],
    field: string,
): AuditLogDiff | undefined {
    return diffs.find((d) => d.field === field);
}
